module.exports = __webpack_public_path__ + "static/whatcaniget-Graphic@3x-e3dc23b1398790afe0e4321b459840ee.png";